$(document).on("turbolinks:load", common_events);
function common_events() {
  $(".confirmation-protocol-input").on("change", function () {
    $(this).next().find(".success").css("display", "block");
    $(this).next().find(".default").css("display", "none");
  });
}
